export default "__VITE_ASSET__0886d183__"